import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Button,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import AnnouncementIcon from '@material-ui/icons/Announcement';
import InfoHistorialIcon from "../UI/InfoHistorialIcon";
import IconEstado from "../UI/IconEstado";
import { PracticaItem } from "./PracticaItem";
import { ModalAuditar } from "./ModalAuditar";
import { ModalHistorialCambios } from "./ModalHistorialCambios";
import { getTraerSolicitudPorIdSolicitud, postTomarSolicitud, putCancelarSolicitud, putLiberarSolicitud, setActiveStep, setAfiliadoSeleccionado, setShowForm, setSolicitud } from "../../../actions/autorizaciones/Autorizaciones";

import { AUTORIZACIONES_BANDEJAS, AUTORIZACIONES_SOLICITUDES_ESTADOS, STEPPER_AUTORIZACIONES, TIPOS_AUTORIZACIONES } from "../../../utils/constants";
// import SeguimientoSolicitud from "./SeguimientoSolicitud";
import SeguimientoSolicitud from "./SeguimientoSolicitud";
import moment from "moment";
import { AlertFinalizadoStepper } from "../../stepper/AlertFinalizadoStepper";
import { CheckCircleIcon } from "@material-ui/data-grid";

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export const SolicitudItem = (props) => {
  const dispatch = useDispatch();
  const { item, estadoSolicitudes } = props;
  const { solicitudesTomadasUsuario } = useSelector((state) => state.autorizaciones);
  const { idUsuario } = useSelector((state) => state.auth);
  // const { solicitudes: solicitud } = useSelector((state) => state.autorizaciones);
  const [open, setOpen] = React.useState(props.expandirPracticas);
  const [openAlert, setOpenAlert] = React.useState(false);
  const [soloVisualizacion, setSoloVisualizacion] = useState(true);
  const [openModalAuditar, setOpenModalAuditar] = useState(false);
  const [openModalHistorialCambios, setOpenModalHistorialCambios] =
    useState(false);
  const [confirmarCancelar, setConfirmarCancelar] = useState(false);
  const [itemTomado, setItemTomado] = useState(null);
  const classes = useRowStyles();

  //   useEffect(()=>{
  //     
  //     dispatch(getSolicitudesTomadasPorUsuario());
  //   }, [dispatch, idUsuario])

  const postIrASolicitud = (item) => {
    props.setRedirect(true);
    dispatch(setSolicitud(item));
    dispatch(setAfiliadoSeleccionado(item.afiliado));
    dispatch(setShowForm(true));
    //dispatch(setActiveBreadcrumb(MENU_AUTORIZACIONES.INGRESO_AUTORIZACION));
    dispatch(setActiveStep(STEPPER_AUTORIZACIONES.DETALLES_ORDEN));
  }

  useEffect(() => {
    if (props.location.state?.fromHomeScreen && props.location.state?.idSolicitud === item.idSolicitud) {
      if (item.solicitudesTomadas.length > 0 || solicitudesTomadasUsuario.filter((item) => item.idUsuarioTomada === idUsuario && item.fechaLiberada === null).length === 0) {
        dispatch(postTomarSolicitud(item, setOpenModalAuditar));
        props.location.state = {};
      } else if (solicitudesTomadasUsuario.filter((item) => item.idUsuarioTomada === idUsuario && item.fechaLiberada === null).length > 0) {
        setOpenAlert(true);
      };
    };
  }, [props.location.state?.fromHomeScreen, props.location.state?.idSolicitud, item.solicitudesTomadas, dispatch]);

  useEffect(() => {
    if (parseInt(estadoSolicitudes) !== AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE
      && parseInt(estadoSolicitudes) !== AUTORIZACIONES_SOLICITUDES_ESTADOS.DEVOLUCION
      && parseInt(estadoSolicitudes) !== AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_MATERIALES
      && parseInt(estadoSolicitudes) !== AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_ADMINISTRATIVA
      && parseInt(estadoSolicitudes) !== AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_DOMICILIARIA
      && parseInt(estadoSolicitudes) !== AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_PAIS
      && parseInt(estadoSolicitudes) !== AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_TERRENO)
      setOpen(false);
  }, [estadoSolicitudes])

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };
  const handleLiberar = () => {
    dispatch(putLiberarSolicitud(
      itemTomado,
      'currentUser',
      props.location.state?.fromHomeScreen,
      setOpenAlert,
      item,
      setOpenModalAuditar,
      setSoloVisualizacion,
      parseInt(estadoSolicitudes),
      true
    ));
    setOpenAlert(false);
  };

  const tieneTresPeriodosSinMovimientos = (practicas) => {
    let periodosPracticas = [];

    practicas.forEach((practica) => practica.periodos.forEach((periodo) => periodosPracticas.push(parseInt(periodo.periodo))));

    const periodoMin = Math.min(...periodosPracticas)
    const fechaPeriodoMinimo = moment(`${periodoMin}01`);
    const fechaPeriodoActual = moment(`${moment().year()}${("0" + (moment().month() + 1)).slice(-2)}01`);
    const mesesSinActividad = fechaPeriodoActual.diff(fechaPeriodoMinimo, 'months');

    if (mesesSinActividad >= 3)
      return true;
    return false;
  }

  const esDenunciaInterDomSinMovimientos = (item?.idTipoSolicitud ===
    TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA) && (item?.idEstadoSolicitud ===
      AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE) && (!item?.fechaCiereInterDom) &&
    tieneTresPeriodosSinMovimientos(item?.practicas);


  const permiteRetomarCarga = (idTipoSolicitud) => {
    if (props.permisoIngresoInterDom && idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA)
      return true;
    else if (props.permisoIngresoAutorizaciones && idTipoSolicitud !== TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA)
      return true;

    return false;
  }

  const permiteAuditar = (idBandejaAutorizacion) => {
    if (props.bandejasAutorizacion.filter(s => s.idBandeja === idBandejaAutorizacion).length > 0)
      return true;

    return false;
  }


  const esSoloAfiliaciones = props.bandejasAutorizacion.length === 1
    && props.bandejasAutorizacion.filter(s => s.idBandeja === AUTORIZACIONES_BANDEJAS.AFILIACIONES).length === 1;

  const handleSendEliminarComprobanteEnCarga = (idSolicitud) => {
    dispatch(
      putCancelarSolicitud(
        idSolicitud,
        () => {
          setOpenModalAuditar(false);
        },
        true,
        null,
        props.filtros,
        null,
        null
      )
    )
  }

  return (
    <>
      {openAlert && (
        <Dialog
          open={openAlert}
          onClose={handleCloseAlert}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Typography
                style={{ color: "#222" }}
              >
                Actualmente tiene una solicitud tomada, desea liberarla para tomar la solicitud N°{item.idSolicitud}?
              </Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleCloseAlert}
              variant="contained"
              color="primary"
            >
              Cancelar
            </Button>
            <Button
              onClick={handleLiberar}
              variant="contained"
              color="primary"
              autoFocus
            >
              Liberar
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {openModalAuditar && (
        <ModalAuditar
          open={openModalAuditar}
          closeModalHandler={() => {
            setOpenModalAuditar(false);
          }}
          solicitud={item}
          disabled={soloVisualizacion}
          permisoIngresoInterDom={props.permisoIngresoInterDom}
          filtros={props.filtros}
          seguimiento={false}
          setRedirect={props.setRedirect}
        />
      )}
      {openModalHistorialCambios && (
        <ModalHistorialCambios
          open={openModalHistorialCambios}
          closeModalHandler={() => {
            setOpenModalHistorialCambios(false);
          }}
          solicitud={item}
          titulo={`Solicitud N° ${item.idSolicitud}`}
        />
      )}
      <AlertFinalizadoStepper
        open={confirmarCancelar}
        pregunta={"Cancelar Solicitud"}
        dialogText={`Esta seguro de cancelar la Solicitud N° ${item.idSolicitud} de ${item.afiliado?.apellido_y_nombre} del tipo ${item.tipoSolicitud.descripcionTipo}?`}
        buttonCancel={"Cancelar"}
        buttonSubmit={"Confirmar"}
        handleClose={() => setConfirmarCancelar(false)}
        handleSend={() => handleSendEliminarComprobanteEnCarga(item.idSolicitud)}
        filtros={props.filtros}
      />
      <TableRow className={classes.root} style={{ backgroundColor: esDenunciaInterDomSinMovimientos && 'lightblue' }}>
        <TableCell align="center" sx={{ padding: "10px" }}>
          <InfoHistorialIcon onClick={() => setOpenModalHistorialCambios(true)} />
        </TableCell>
        <TableCell align="right">
          {item.urgente && (
            <IconEstado
              texto={"U"}
              useColorTable={true}
              descripcion={'Urgente'}
              extraMarginRight={true}
              backgroundColor={"red"}
            />
          )}
          <IconEstado
            useColorTable={true}
            texto={item?.estadosSolicitud?.letra}
            backgroundColor={item?.estadosSolicitud?.color}
            descripcion={item?.estadosSolicitud?.descripcion}
          />
        </TableCell>
        <TableCell align="center">
          {parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.EN_CARGA /*||
          parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_EVALUACION_APP_HCE*/
            ? new Date(item.fecha).toLocaleString("es", optionsfecha)
            : parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA
              ? new Date(item.fechaEgreso).toLocaleString("es", optionsfecha)
              : parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_MATERIALES
                ? new Date(item.fechaDerivacion).toLocaleString("es", optionsfecha)
                : (item.fechaEnviada !== null ? new Date(item.fechaEnviada).toLocaleString("es", optionsfecha) : "")
          }
        </TableCell>
        <TableCell align="left">{item.idSolicitud}</TableCell>
        <TableCell align="left">{item.tipoSolicitud.descripcionTipo}</TableCell>
        <TableCell align="left">{item.conInternacion ? 'SI' : 'NO'}</TableCell>
        <TableCell align="left">{item.diagnostico?.problema}</TableCell>
        <TableCell>
          {item.practicas.length > 0 && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => {
                if (!open)
                  dispatch(getTraerSolicitudPorIdSolicitud(item.idSolicitud, parseInt(estadoSolicitudes), false, null, setOpen(!open)));
                else
                  setOpen(!open)
              }}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCell>
        <TableCell align="left">{(item.idMotivoInternacion && item.idMotivoInternacion !== 4) ? 'SI' : 'NO'}</TableCell>
        <TableCell align="left">{item.afiliado?.apellido_y_nombre}</TableCell>
        <TableCell align="left">{item.afiliado?.carnet}</TableCell>
        <TableCell align="left">
          {item.seccional?.descripcion_seccional}
        </TableCell>
        {(parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_TERRENO ||
          parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_PAIS) &&
          <TableCell align="left">{item.efectorDenunciaInternacion}</TableCell>
        }
        {/* <TableCell align="left">
          {item.bandejasAutorizacion?.descripcion}
        </TableCell> */}
        <TableCell align="left">
          {item.solicitudesTomadas[0]?.usuarioTomada?.userName}
        </TableCell>
        {parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_DOMICILIARIA
          && <TableCell align="left">
            {(item.tienePendientePracticas || item.tienePendientePeriodos || item.tienePendienteMateriales)
            /*&& parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_DOMICILIARIA*/ ?
              <Tooltip title='Esta solicitud tiene cambios pendientes'>
                <AnnouncementIcon style={{ color: 'red' }} />
              </Tooltip>
              :
              ""
            }
          </TableCell>}
        {parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.OXIGENO
          && <TableCell align="left">
            {(item.tienePendientePracticasOxigeno || item.tienePendientePeriodosOxigeno || item.tienePendienteMaterialesOxigeno)
            /*&& parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_DOMICILIARIA*/ ?
              <Tooltip title='Esta solicitud tiene cambios pendientes'>
                <AnnouncementIcon style={{ color: 'red' }} />
              </Tooltip>
              :
              ""
            }
          </TableCell>}

        {parseInt(estadoSolicitudes) !== AUTORIZACIONES_SOLICITUDES_ESTADOS.PRACTICAS_INTERNACION &&
          <TableCell align="left">
            {item?.bandejasAutorizacion?.descripcion}
          </TableCell>
        }

        <TableCell align="left">
          {(item?.idTipoSolicitud === TIPOS_AUTORIZACIONES.ESTADIAS || item?.idTipoSolicitud === TIPOS_AUTORIZACIONES.PASAJES) 
          && item?.pasajeEstadiaAprobado
            ?
            <Tooltip title='Solicitud aprobada por Auditoría Médica'>
              <CheckCircleIcon style={{ color: 'green' }} />
            </Tooltip>
            :
            ""
          }
        </TableCell>

        {(parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.EN_CARGA
          || parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE
          || parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_EVALUACION_APP_HCE
          || parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.DEVOLUCION)
          && !esSoloAfiliaciones
          && <TableCell align="left">
            <Button
              style={{ fontSize: "0.8rem" }}
              variant="contained"
              color="primary"
              onClick={() => setConfirmarCancelar(true)}
            >
              Eliminar
            </Button>
          </TableCell>}
        {(parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_TERRENO ||
          parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_PAIS ||
          parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA ||
          parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_DOMICILIARIA) &&
          <TableCell align="left">
            <SeguimientoSolicitud
              mouseEvent
              seguimiento={item.seguimiento}
            />
          </TableCell>
        }
        <TableCell>
          {(props.permisoIngresoInterDom || props.permisoIngresoAutorizaciones) &&
            ((item?.idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.DEVOLUCION && !item?.fromAppMobile) ||
              item?.idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.EN_CARGA ||
              item?.idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_EVALUACION_APP_HCE)
            && !esSoloAfiliaciones
            && permiteRetomarCarga(item?.idTipoSolicitud)
            && (
              <Button
                style={{ fontSize: "0.8rem" }}
                variant="contained"
                color="primary"
                onClick={() => {
                  postIrASolicitud(item);
                }}
              >
                Ir
              </Button>
            )}
          {(item?.idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE ||
            item?.idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_MATERIALES ||
            (item?.idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.DEVOLUCION && item?.fromAppMobile) ||
            item?.idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_ADMINISTRATIVA)
            && permiteAuditar(item?.idBandejaAutorizacion)
            ?
            <Button
              style={{ fontSize: "0.8rem" }}
              disabled={
                item.solicitudesTomadas?.length > 0 &&
                item.solicitudesTomadas[0]?.idUsuarioTomada !== idUsuario
              }
              variant="contained"
              color="primary"
              onClick={() => {
                // dispatch(postTomarSolicitud(item, setOpenModalAuditar, setSoloVisualizacion));
                dispatch(getTraerSolicitudPorIdSolicitud(item.idSolicitud, parseInt(estadoSolicitudes), true, setSoloVisualizacion,
                  null, setOpenModalAuditar, setOpenAlert, setItemTomado));
              }}
            >
              Auditar
            </Button>
            :
            (item?.idEstadoSolicitud !== AUTORIZACIONES_SOLICITUDES_ESTADOS.DEVOLUCION &&
              item?.idEstadoSolicitud !== AUTORIZACIONES_SOLICITUDES_ESTADOS.EN_CARGA &&
              item?.idEstadoSolicitud !== AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_EVALUACION_APP_HCE) &&
            // ((item?.idEstadoSolicitud ===
            //   AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA) || (
            //    item?.idEstadoSolicitud ===
            //   AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE &&
            //     item?.idTipoSolicitud === 
            //     TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA
            //   )) &&
            <Button
              style={{ fontSize: "0.8rem" }}
              variant="contained"
              color="primary"
              onClick={() => {
                /*
                setOpenModalAuditar(true);
                dispatch(setSolicitud(item));
                */
                dispatch(getTraerSolicitudPorIdSolicitud(item.idSolicitud, parseInt(estadoSolicitudes), true, setSoloVisualizacion,
                  null, setOpenModalAuditar, null, null, false));
              }}
            >
              Ver
            </Button>
          }
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0, paddingLeft: 100 }}
          colSpan={11}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Practicas
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Estado Práctica</TableCell>
                    <TableCell>Práctica</TableCell>
                    <TableCell align="right">Cantidad</TableCell>
                    <TableCell align="center">SURGE</TableCell>
                    <TableCell>Materiales</TableCell>
                    <TableCell>Institucion</TableCell>
                    {(item.conInternacion || item.idPrestacion) &&
                      <TableCell>Profesional</TableCell>
                    }
                  </TableRow>
                </TableHead>
                <TableBody>
                  {item.practicas.map((practica) => (
                    <PracticaItem
                      key={practica?.idCodNom?.toString()}
                      conInternacion={item.conInternacion}
                      idPrestacion={item.idPrestacion}
                      item={practica}
                      materialCotizacion={item.cotizaciones}
                      estadoSolicitud={item?.idEstadoSolicitud}
                      idTipoSolicitud={item?.idTipoSolicitud}
                      filtros={props.filtros}
                    />
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};
